import React from 'react';
import Card from '../../shared/components/Card';
import CardSimpleHeader from '../../shared/components/CardSimpleHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CardBody from '../../shared/components/CardBody';
import OutsourceForm from './OutsourceForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as outsourceActions from '../actions/outsourceActions';
import * as importOutsourceActions from '../actions/importOutsourceActions';
import Row from '../../shared/components/Row';

class AddOutsourceCard extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillUnmount() {
        // Limpiamos la subcontrata a importar.
        this.props.importOutsourceActions.importOutsource(null);
    }

    onSubmit(values) {
        if ( values.nif && values.name ) {
            this.props.outsourceActions.addCompany(values);
        }
    }

    render() {
        const {
            outsourceAssignmentLoading,
            outsourceLoading
        } = this.props;

        return (
            <Row>
                <Card loading={outsourceAssignmentLoading || outsourceLoading}>
                    <CardSimpleHeader title={I18nUtils.tr('TR_NUEVA_SUBCONTRATA')}/>
                    <CardBody>
                        <OutsourceForm
                            addForm={true}
                            onSubmit={this.onSubmit}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        outsourceAssignmentLoading: state.outsources.outsourceAssignmentLoading,
        outsourceLoading: state.outsources.outsourceLoading,
    };
};

const mapDispatchToProps = dispatch => ( {
    outsourceActions: bindActionCreators(outsourceActions, dispatch),
    importOutsourceActions: bindActionCreators(importOutsourceActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(AddOutsourceCard);

AddOutsourceCard.propTypes = {};

AddOutsourceCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/outsource/components/AddOutsourceCard.js